module.exports = __webpack_public_path__ + "img/xls.ade5c272.png";